import React from 'react';
import AsyncSelect from "react-select/async";
import { FaSearch, FaInfoCircle } from "react-icons/fa";

const AccountSelectField = ({ 
  label, 
  value, 
  onChange, 
  placeholder, 
  helpText, 
  loadAccountOptions 
}) => {
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#0C5B6D" : "#d1d5db",
      borderRadius: "0.5rem",
      padding: "0.125rem",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(12, 91, 109, 0.2)" : "none",
      "&:hover": { borderColor: "#0C5B6D" },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.data.isCreateOption
        ? state.isFocused ? "#fef3c7" : "#fffbeb"
        : state.isSelected ? "#0C5B6D" : state.isFocused ? "#F1F6FC" : "white",
      color: state.data.isCreateOption ? "#FB923C" : state.isSelected ? "white" : "#374151",
      padding: "0.75rem 1rem",
    }),
    placeholder: (provided) => ({ ...provided, color: "#9ca3af", fontSize: "0.875rem" }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        value={value ? { value, label: value } : null}
        onChange={onChange}
        placeholder={placeholder}
        styles={customSelectStyles}
        loadingMessage={() => (
          <div className="flex items-center gap-2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#0C5B6D]" />
            <span>Recherche en cours...</span>
          </div>
        )}
        noOptionsMessage={({ inputValue }) =>
          inputValue.length < 2 ? "Saisissez au moins 2 caractères" : "Aucun compte trouvé"
        }
        isClearable
        isSearchable
        components={{
          DropdownIndicator: () => (
            <div className="px-2">
              <FaSearch className="text-gray-400" size={14} />
            </div>
          ),
        }}
      />
      {helpText && (
        <div className="flex items-start gap-2 mt-1 text-xs text-gray-500">
          <FaInfoCircle className="mt-0.5 flex-shrink-0" size={12} />
          <span>{helpText}</span>
        </div>
      )}
    </div>
  );
};

export default AccountSelectField;